import React from 'react';
import ReactDOM from 'react-dom';
import PropTypes from 'prop-types';

class PortalOverlay extends React.Component {
  constructor(props) {
    super(props);
    this.el = document.createElement('div');
    this.el.className = props.divClassName;
  }

  componentDidMount() {
    const { modalRoot } = this.props;
    if (modalRoot) {
      modalRoot.appendChild(this.el);
    }
  }

  componentWillUnmount() {
    const { modalRoot } = this.props;
    if (modalRoot) {
      modalRoot.removeChild(this.el);
    }
  }

  render() {
    return ReactDOM.createPortal(this.props.children, this.el);
  }
}

PortalOverlay.propTypes = {
  divClassName: PropTypes.string,
  modalRoot: PropTypes.object,
};

export default PortalOverlay;



// WEBPACK FOOTER //
// ./src/pages/pointofsale/modules/common/component/PortalOverlay.js